<h2 mat-dialog-title="mat-dialog-title">
  @if (titleText) {
    {{ titleText }}
  } @else {
    {{ "MODAL.TITLE." + title | translate }}
  }
</h2>
<mat-dialog-content class="mat-typography body">
  @if (bodyLines.length) {
    @for (line of bodyLines; track $index) {
      <p class="body-line">{{ line }}</p>
    }
  } @else {
    {{ "MODAL.BODY." + body | translate }}
  }
</mat-dialog-content>
  <mat-dialog-actions class="dialog-actions">
    @for (btn of buttons; track btn) {
      <button
        mat-raised-button
        mat-dialog-close
        color="{{ btn.color }}"
        [class]="btn.action"
        (click)="doAction(btn.action)"
        >
        {{ "MODAL.BUTTONS." + btn.title | translate }}
      </button>
    }
  </mat-dialog-actions>
